<template>
  <div
    :class="{ 'has-logo': showLogo }"
    class="sidebar-inner"
    :style="{
      backgroundColor: settings.sideTheme === 'theme-dark' ? variables.menuBackground : variables.menuLightBackground,
    }"
  >
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar :class="settings.sideTheme" wrap-class="scrollbar-wrapper">
      <el-menu :default-active="activeMenu" :collapse="isCollapse" class="menu-content" :background-color="settings.sideTheme === 'theme-dark' ? variables.menuBackground : variables.menuLightBackground" :text-color="settings.sideTheme === 'theme-dark' ? variables.menuColor : variables.menuLightColor" :unique-opened="true" :active-text-color="settings.theme" :collapse-transition="false" mode="vertical">
        <sidebar-item class="menu-content" v-for="(route, index) in sidebarRouters" :key="route.path + index" :item="route" :base-path="route.path" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex';
  import Logo from './Logo';
  import SidebarItem from './SidebarItem';
  import variables from '@/assets/styles/variables.scss';

  export default {
    components: { SidebarItem, Logo },
    computed: {
      ...mapState(['settings']),
      ...mapGetters(['sidebarRouters', 'sidebar']),
      activeMenu() {
        const route = this.$route;
        const { meta, path } = route;
        // if set path, the sidebar will highlight the path you set
        if (meta.activeMenu) {
          return meta.activeMenu;
        }
        return path;
      },
      showLogo() {
        return this.$store.state.settings.sidebarLogo;
      },
      variables() {
        return variables;
      },
      isCollapse() {
        return !this.sidebar.opened;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .sidebar-inner {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .el-menu {
    background-color: rgba(0, 0, 0, 0) !important;
  }

  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 3px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.5);
  }

  ::v-deep .el-scrollbar {
    overflow: hidden !important;
    flex: 1 1 auto;
    height: auto;
  }

  ::v-deep .has-logo .el-scrollbar {
    height: auto !important;
  }

  ::v-deep:not(.has-logo) .el-scrollbar {
    height: auto !important;
  }

  ::v-deep .scrollbar-wrapper {
    overflow-y: auto !important;
    overflow-x: hidden !important;
    max-height: 100%;
  }

  ::v-deep .menu-content li {
    .el-submenu__title {
      padding-left: 16px !important;
    }
  }
  ::v-deep .menu-content > li {
    margin: 5px 8px !important;
    &.is-active {
      background-color: rgba(12, 95, 217, 1) !important;
      border-radius: 8px;
    }
  }
  ::v-deep .menu-content > a > li {
    display: flex;
    align-items: center;
    .el-submenu__title {
    }
    background-color: rgba(0, 0, 0, 0) !important;
    margin: 0 8px;

    .el-submenu__title,
    &:hover {
      background-color: #1e78e7 !important;
      border-radius: 8px !important;
      font-weight: normal !important;
    }
    &.is-active {
      font-weight: bold !important;
      color: #3087ee !important;
      background-color: #fff !important;
      border-radius: 8px !important;
      font-weight: bold;
      svg {
        color: #3087ee;
        stroke: currentColor;
        stroke-width: 3;
        paint-order: stroke;
      }
    }
  }
</style>
